import React from 'react';
import Hero from '../../components/hero/Hero';
import ProductsSection from '../../components/products/ProductsSection';
import ServicesSection from '../../components/services/ServicesSection';
import PricingSection from '../../components/pricing/PricingSection';
import ContactSection from '../../components/contact/ContactSection';
import { Seo } from '../../components/Seo';
import { keywordsFlow, keywordsPay, keywordsRx } from '../../seo/keywords';
import { organizationJsonLd, websiteJsonLd } from '../../seo/site';
import { useMarket } from '../../context/MarketContext';

const Home: React.FC = () => {
  const { market } = useMarket();

  return (
    <>
      <Seo
        title={
          market === 'US'
            ? 'Cimmple | Machine Shop ERP & Cloud OS for CNC Shops'
            : 'Cimmple | Pharmacy ERP & Machine Shop Software India'
        }
        description={
          market === 'US'
            ? 'CimmpleFlow is manufacturing ERP and a cloud operating system for machine shops and CNC job shops—plus CimmplePay payroll software.'
            : 'CimmpleRx pharmacy ERP for India and CimmpleFlow machine shop ERP—billing, GST, inventory, and shop operations in one platform.'
        }
        keywords={
          market === 'US'
            ? [...keywordsFlow, ...keywordsPay]
            : [...keywordsRx, ...keywordsFlow]
        }
        jsonLd={{
          '@context': 'https://schema.org',
          '@graph': [organizationJsonLd, websiteJsonLd],
        }}
      />
      <Hero />
      <ProductsSection />
      <PricingSection />
      <ServicesSection />
      <ContactSection />
    </>
  );
};

export default Home;
